module.exports = __webpack_public_path__ + "img/step2.b1b95c5a.png";